<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="loading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div v-if="!loading" class="flex xs12">
      <va-card :title="createTitle()">
      </va-card>
    </div>
    <div v-if="!loading" class="flex xs12">
      <FreeAppSubscription @handle-loader="handleLoader" :app-subscription-obj="appSubscription" v-if="subscriptionType === 'free' && isInit" />
      <FixAppSubscription @handle-loader="handleLoader" :app-subscription-obj="appSubscription" v-if="subscriptionType === 'fix' && isInit" />
      <ChargesAppSubscription @handle-loader="handleLoader" :app-subscription-obj="appSubscription" v-if="subscriptionType === 'charge' && isInit" />
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import FixAppSubscription from '../appSubscriptions/updateSubscriptionType/FixAppSubscription'
import FreeAppSubscription from '../appSubscriptions/updateSubscriptionType/FreeAppSubscription'
import ChargesAppSubscription from '../appSubscriptions/updateSubscriptionType/ChargesAppSubscription'

export default {
  components: { SwappingSquaresSpinner, FixAppSubscription, FreeAppSubscription, ChargesAppSubscription },
  name: 'UpdateAppSubscription',
  data () {
    return {
      appSubscriptionId: 0,
      subscriptionType: null,
      loading: false,
      appSubscription: null,
      isInit: false,
    }
  },
  methods: {
    toDashboard () {
      this.$router.push({
        name: 'app-subscriptions',
      })
    },
    handleLoader (state) {
      this.loading = state
    },
    createTitle () {
      return this.$t('subscriptions.updateSubscriptionTitle')
    },
    async getAppSubscription () {
      await this.$store.dispatch('getAppSubscription', this.appSubscriptionId).then((resp) => {
        this.appSubscription = resp.data.message
        this.isInit = true
      })
    },
  },
  watch: {
  },
  computed: {
  },
  mounted () {
    this.subscriptionType = this.$route.params.type
    this.appSubscriptionId = Number.parseInt(this.$route.params.appSubscriptionId)
    if (this.subscriptionType === null || !this.appSubscriptionId) {
      this.toDashboard()
    }
    this.getAppSubscription()
  },
}
</script>

<style scoped>

</style>
